module.exports = __webpack_public_path__ + "static/img/strona_003.59fa206f.jpg";